/**
 * Toast System Constants
 * 
 * Defines toast types, positioning, and default configurations.
 */

/**
 * Toast appearance types matching Figma design
 */
export const TOAST_TYPES = Object.freeze({
    SUCCESS: 'success',
    ERROR: 'error',
    WARNING: 'warning',
    INFO: 'info',
    NORMAL: 'normal',
});

/**
 * Default durations in milliseconds
 */
export const TOAST_DURATIONS = Object.freeze({
    SHORT: 3000,
    DEFAULT: 5000,
    LONG: 8000,
    PERSISTENT: null, // Won't auto-close
});

/**
 * Toast positioning configuration
 * Toasts appear 24px from bottom, 24px to the right of sidebar
 */
export const TOAST_POSITION = Object.freeze({
    BOTTOM: 24,
    RIGHT_OF_SIDEBAR: 24,
});

/**
 * Toast portal root element ID
 */
export const TOAST_PORTAL_ROOT_ID = 'toast-root';

/**
 * Maximum number of toasts visible at once
 */
export const MAX_VISIBLE_TOASTS = 5;

/**
 * Animation durations
 */
export const TOAST_ANIMATIONS = Object.freeze({
    ENTER_DURATION: 400,
    EXIT_DURATION: 300,
});

/**
 * Icon names for each toast type (using existing icon system)
 */
export const TOAST_ICONS = Object.freeze({
    [TOAST_TYPES.SUCCESS]: 'CheckCircle',
    [TOAST_TYPES.ERROR]: 'XCircle',
    [TOAST_TYPES.WARNING]: 'AlertTriangle',
    [TOAST_TYPES.INFO]: 'Info',
    [TOAST_TYPES.NORMAL]: 'Bell',
});

export default {
    TOAST_TYPES,
    TOAST_DURATIONS,
    TOAST_POSITION,
    MAX_VISIBLE_TOASTS,
    TOAST_ANIMATIONS,
    TOAST_ICONS,
};

